var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMapOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 3.5A3.754 3.754 0 0121 7.25c0 1.36-1.946 4.047-3.75 6.064-1.804-2.017-3.75-4.704-3.75-6.064a3.754 3.754 0 013.75-3.75zm5.25 3.75a5.25 5.25 0 10-10.5 0c0 3 5.25 8.25 5.25 8.25s5.25-5.25 5.25-8.25zM8.25 21.286L3 19.68l-.004-10.5 5.084 1.543c.034.01.07.017.104.024l.066.014v10.526zm12.005-.29l-4.272-1.44a1.394 1.394 0 00-.145-.037l-.088-.02V16.11c-.385-.402-.916-.98-1.5-1.673v5.08l-.088.022c-.065.015-.129.031-.191.055L9.75 21.198V10.727l.083-.021c.058-.014.116-.028.172-.05l1.318-.5a9.479 9.479 0 01-.562-1.39l-1.288.488a1.496 1.496 0 01-.958.032L3.43 7.743a1.504 1.504 0 00-.433-.064A1.51 1.51 0 001.5 9.196V19.68c0 .67.434 1.26 1.07 1.453l5.946 1.804a1.485 1.485 0 00.957-.033l5.03-1.907a1.496 1.496 0 011.001-.018l4.271 1.44c.16.053.32.079.477.079a1.51 1.51 0 001.498-1.518v-8.474a29.27 29.27 0 01-1.498 1.93l.003 6.56zM17.25 5.375a1.875 1.875 0 110 3.75 1.875 1.875 0 010-3.75z",
    fill: "currentColor"
  })));
}

export default SvgIconMapOutline;